<template>
  <div class="sim-prods-swiper swiper-container similar-products">
    <h2 class="sim-prods-swiper__name">Похожие товары</h2>

    <swiper
      :navigation="{
        prevEl: '#ts-arr-prev',
        nextEl: '#ts-arr-next',
      }"
      :breakpoints="thumbsOptions.breakpoints"
      :slides-per-view="2"
      :space-between="10"
      :freeMode="true"
      :watchSlidesVisibility="true"
    >
      <swiper-slide v-for="analog in analogs" :key="analog.id" class="hui">
        <div class="product product_grid">
          <router-link
            :to="{ name: 'product', params: { product_slug: analog.slug } }"
            class="product__main"
          >
            <div class="product__outer-image-container">
              <div class="product__medium-image-container">
                <div class="product__internal-image-container">
                  <img
                    :src="`${img_url}${analog.image}`"
                    alt=""
                    class="product__image"
                  />
                </div>
              </div>
            </div>
            <div class="product__info-container">
              <h4 class="product__name">
                <span class="product__name-text">{{ analog.name }}</span>
              </h4>
              <div class="product__meta">
                <div class="product__meta-cell">
                  <strong class="product__meta-name">Код:</strong>
                  <span class="product__meta-value">{{ analog.code_1c }}</span>
                </div>
                <div class="product__meta-cell">
                  <strong class="product__meta-name">Арт.:</strong>
                  <span class="product__meta-value">{{ analog.article }}</span>
                </div>
              </div>
            </div>
          </router-link>
          <div class="product__aside">
            <div class="product__price-container">
              <div class="product__price">
                {{ analog.price_name }} <span class="currency">&#8381;</span>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>

    <div
      class="
        sim-prods-swiper__arrow
        pagination-button pagination-button_arrow
        spwar-prev
        prev
      "
      id="ts-arr-prev"
    ></div>
    <div
      class="
        sim-prods-swiper__arrow
        pagination-button pagination-button_arrow
        spwar-next
        next
      "
      id="ts-arr-next"
    ></div>
  </div>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/thumbs/thumbs.min.css";

// import Swiper core and required modules
import SwiperCore, { Navigation, Thumbs } from "swiper/core";

// install Swiper modules
SwiperCore.use([Navigation, Thumbs]);

export default {
  name: "ProductAnalogs",
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
      thumbsSwiper: null,
      thumbsOptions: {
        breakpoints: {
          440: {
            slidesPerView: 3,
            spaceBetween: 10,
            freeMode: false,
          },
          760: {
            slidesPerView: 4,
            spaceBetween: 10,
            freeMode: false,
          },
          1141: {
            slidesPerView: 4,
            spaceBetween: 20,
            freeMode: false,
          },
        },
      },
    };
  },
  computed: {
    analogs() {
      return this.$store.getters["product/GET_ANALOGS"];
    },
    analogsLenght() {
      return this.$store.getters["product/GET_ANALOGS_LENGTH"];
    },
  },
};
</script>

<style scoped></style>
